import "reflect-metadata";
import { ApiPrefixInterceptor } from "../interceptors/api-prefix.interceptor";

export enum ModuleEnum {
  GAD = 'GAD',
  MASTER_DATA = 'MASTER_DATA',
}

export function ApiModule(module : ModuleEnum) {
  return function (target: Function) {
    ApiPrefixInterceptor.module = module;
  };
}
  